export default "__VITE_ASSET__D16Blj8N__"